// extracted by mini-css-extract-plugin
export default {"placeholder":"areaActionResult_placeholder__0Hjna"};